<template>
    <span>
        <b-button
            variant="primary"
            @click.stop="confirmarEnvioParaAnalise()"
            v-if="mostrarBtnEnviarParaAnalise"
        >
            <span>
                <i class="fa fa-arrow-circle-right"></i> Enviar para análise
            </span>
        </b-button>
        <span class="ml-2" v-if="mostrarMensagem">
            <strong
                >Fora do prazo permitido de envio para análise. Liberado a
                partir de {{ $maskDate(pagamento.dataEnvioPermitido) }}.</strong
            >
        </span>
    </span>
</template>

<script>
import { pagamentoStatus } from './PagamentoStatus'

export default {
    props: {
        pagamento: {
            type: Object,
            required: true
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarEnvioParaAnalise() {
            this.$swal({
                title: 'Envio para Análise',
                html: `Confirma o envio do registro de pagamento para análise?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.enviarParaAnalise()
                }
            })
        },

        enviarParaAnalise() {
            let pagamentoDto = {
                pagamentoId: this.pagamento.pagamentoId
            }
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .enviarPagamentoParaAnalise(pagamentoDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Enviado para análise com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterPagamentoAtualizado')
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERRO',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnEnviarParaAnalise() {
            return (
                (this.pagamento.status === pagamentoStatus.CRIADO ||
                    this.pagamento.status === pagamentoStatus.REPROVADO) &&
                this.pagamento.qtdComprometimentos > 0 &&
                this.pagamento.qtdAnexos > 0 &&
                this.$temAcesso('CONT-PAG-04') &&
                this.pagamento.envioPermitido
            )
        },

        mostrarMensagem() {
            return (
                this.pagamento.status === pagamentoStatus.CRIADO &&
                this.pagamento.qtdComprometimentos > 0 &&
                this.pagamento.qtdAnexos > 0 &&
                this.$temAcesso('CONT-PAG-04') &&
                !this.pagamento.envioPermitido &&
                !this.pagamento.solicitacaoParaEnvioEmAnalise
            )
        }
    }
}
</script>
